module.exports = __webpack_public_path__ + "img/grass-on-golf-backgrounds.3a82508a.jpg";